import type { ChatRole } from '../../../store/slices/chat/types';
import { parseChatMessage } from '../../../utils/chat';
import { Fetcher } from '../../Fetcher';

import type { ITableLevelMessagesResponse, TableLevelMessagesType } from './types';

export interface FetchTableLevelMessagesParams {
  url: string;
  offset: number;
  recordsPerPage: number;
  tableId: string;
  tagMessage: ChatRole;
  userId: string | null;
  showOtherMessages: boolean;
}

export const fetchTableLevelMessages = ({
  url,
  offset,
  recordsPerPage,
  tableId,
  tagMessage,
  userId,
  showOtherMessages,
}: FetchTableLevelMessagesParams): Promise<TableLevelMessagesType> => {
  return Fetcher.fetch<ITableLevelMessagesResponse>(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      offset,
      recordsPerPage,
      tableId,
      tagMessage,
      userId,
      showOtherMessages,
    },
  }).then((response) => {
    // Filter out duplicates by messageId
    const uniqueMessages = response.list.filter(
      (message, index, self) => index === self.findIndex((m) => m.messageId === message.messageId)
    );

    // Sort unique messages by timestamp in ascending order
    const sortedMessages = uniqueMessages.sort((a, b) => a.timestamp - b.timestamp);
    return sortedMessages.map((message) => parseChatMessage(message));
  });
};
